export function detectDeviceType() {
  const ua = navigator.userAgent;
  const isIOS = /(iPhone|iPad|iPod|Macintosh)/i.test(ua) && 'ontouchend' in document;
  const isAndroid = /(Android|Adr)/i.test(ua);

  if (isIOS) { return 'ios'; }
  if (isAndroid) { return 'android'; }
  return 'pc';
}

export const getWebPlatform = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isMobile = /(android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|palm|symbian|windows phone|harmonyos)/.test(ua);
  if (isMobile) {
    return 'h5';
  } else {
    return 'pc';
  }
};

export function detectOS() {
  const ua = navigator.userAgent;
  const osInfo = { type: '其他', version: '未知' };

  // 1. 鸿蒙系统检测（优先级最高）
  const harmonyOSMatch = ua.match(/HarmonyOS\/([\d.]+)/i);
  if (harmonyOSMatch) {
    osInfo.type = 'harmony';
    osInfo.version = harmonyOSMatch[1].replace(/_/g, '.'); // 转换为标准版本格式
    return osInfo;
  }

  // 2. iOS 系统检测
  const iosMatch = ua.match(/(iPhone|iPad|iPod).*OS ([\d_]+)/i);
  if (iosMatch) {
    osInfo.type = 'ios';
    osInfo.version = iosMatch[2].replace(/_/g, '.'); // 转换为标准版本格式
    return osInfo;
  }

  // 3. Android 系统检测
  const androidMatch = ua.match(/Android\s+([\d.]+)/i);
  if (androidMatch) {
    osInfo.type = 'android';
    osInfo.version = androidMatch[1];
    return osInfo;
  }
  return osInfo;
}

export const getOsName = function () {
  const webLog = {
    device: '',
    wechat: '',
    system: '',
  };
  const userAgent = navigator.userAgent;
  // 获取微信版本
  let m1 = userAgent.match(/MicroMessenger.*?(?= )/);
  if (m1 && m1.length > 0) {
    webLog.wechat = m1[0];
  }
  // 苹果手机
  if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    // 获取设备名
    if (userAgent.includes('iPad')) {
      webLog.device = 'iPad';
    } else {
      webLog.device = 'iPhone';
    }
    // 获取操作系统版本
    m1 = userAgent.match(/iPhone OS .*?(?= )/);
    if (m1 && m1.length > 0) {
      webLog.system = m1[0];
    }
  }
  // 安卓手机
  if (userAgent.includes('Android')) {
    // 获取设备名
    m1 = userAgent.match(/Android.*; ?(.*(?= Build))/);
    if (m1 && m1.length > 1) {
      webLog.device = m1[1];
    }
    // 获取操作系统版本
    m1 = userAgent.match(/Android.*?(?=;)/);
    if (m1 && m1.length > 0) {
      webLog.system = m1[0];
    }
  }
  return webLog;
};

export const getAppKeyToWeb = function () {
  const url = window.location.hostname;
  let appKey = 'mishop';
  if (url.includes('xiaomiyoupin.com')) {
    appKey = 'youpin';
  }
  return appKey;
};

export const uaTest = function () {
  const uaText = window.navigator && window.navigator.userAgent;
  const miuinewapp =
    /miui\.hybrid/.test(uaText) && /com\.xiaomi\.youpin\./.test(uaText);
  const iOS_app_test =
    (uaText.match(/MiHome/) && uaText.match(/iOS/)) ||
    uaText.match(/^iOS-/) ||
    (uaText.match(/MIOTStore/) && uaText.match(/;I/));
  const iOS_app = Boolean(iOS_app_test);
  const android_app_test =
    uaText.match(/^Android-/) ||
    uaText.match(/MIOTStore/) ||
    uaText.match(/com\.xiaomi\.smarthome/);
  const android_app = Boolean(android_app_test);

  const app = (android_app || iOS_app) && !miuinewapp;
  return {
    app,
  };
};
